import React from 'react';
import { Link } from 'react-router-dom';
import "./Footer.css";

import {
  Container,
} from "reactstrap";





function Footer() {
 
  return (
    <footer className=" text-black pt-2 mt-3" style={{ backgroundColor: "#eff0ee96"}}> {/* Reduced padding */}
      <Container  >

        {/* <div className="row text-center">
          <div className="col-md-1"></div>
          <div className='col-md-4' ><Link style={{ textDecoration: 'none' }} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} to="/contact " className="text-black"> Contact Us</Link></div>
          <div className='col-md-4'><Link style={{ textDecoration: 'none' }} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} to="/downloads" className="text-black">Instructions</Link></div>
          <div className='col-md-4'><Link style={{ textDecoration: 'none' }} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} to="/faqs" className="text-black">FAQs</Link></div>
          <div className='col-md-4' style={{ textAlign: 'right' }}><span>Contact: punjabdesk@hkcl.in  |  0172-5210290/291</span></div>
          <div className="col-md-4 text-center col-xs-6 ">
            <h6>Useful Links</h6> 
            <ul className="list-unstyled">
              <li><Link to="/contact" className="text-black">Contact Us</Link></li>
              <li><Link to="/downloads" className="text-black">Downloads</Link></li>
              <li><Link to="/faqs" className="text-black">FAQs</Link></li>
            </ul>
          </div>
          <div className="col-md-4 text-center">
          </div>
          <div className="col-md-4 col-xs-6 text-center">
          <p>Email Id: punjabdesk@hkcl.in</p>
          <p>Phone No: 0172-5210290/291</p>
        </div>

        </div> */}
        {/* <div className='row mt-2 ' >
          <div className="text-center" style={{ borderTop: "2px solid" }}>
          <div className='col-md-8 mt-1 col-xs-12' style={{ textAlign: 'left' }}>
            <span  style={{ marginBottom: "0" }}>&copy; {new Date().getFullYear()} Email: </span></div>
          <div className='col-md-4 col-xs-12' style={{ textAlign: 'right' }}><span>Contact: gju@gmail.com</span></div>
          </div>
        </div > */}

        <div className=' text-center' >
          {/* <div className="text-center" style={{ borderTop: "2px solid" }}> */}
          <div className='  col-xs-12'  style={{color:'#685f5f'}}>
            <span  style={{ marginBottom: "0" }}> Copyright &copy;  Designed & Developed by  <a href="https://hkcl.in/" target="_blank ">HKCL </a>{new Date().getFullYear()}</span></div>
        <div  className='mt-1 py-1'>
        </div>
        </div>

      </Container >

    </footer >

  );
}

export default Footer;